import React, { Component } from 'react';
import axios from 'axios';
import './style.css';

class ChatContainer extends Component {
	state = {
		messages: [],
		name: '',
		phoneNumber: '',
		numberOfEvents: '',
		eventDate: '',
		eventPlace: '',
		step: 1,
	};

	apiEndpoint = 'https://api.openai.com/v1/engines/text-davinci-002/jobs';
	apiKey = 'your_api_key_here';
	apiHeader = {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${this.apiKey}`,
	};

	handleChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	handleSubmit = async (e) => {
		e.preventDefault();

		switch (this.state.step) {
			case 1:
				if (!this.state.name) {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'chatbot', text: 'Please provide your name.' },
						],
					});
				} else {
					this.setState({
						messages: [...this.state.messages, { type: 'user', text: this.state.name }],
						step: 2,
					});
				}
				break;
			case 2:
				if (!this.state.phoneNumber) {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'chatbot', text: 'Please provide your phone number.' },
						],
					});
				} else {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'user', text: this.state.phoneNumber },
						],
						step: 3,
					});
				}
				break;
			case 3:
				if (!this.state.numberOfEvents) {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'chatbot', text: 'Please provide the number of events.' },
						],
					});
				} else {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'user', text: this.state.numberOfEvents },
						],
						step: 4,
					});
				}
				break;
			case 4:
				if (!this.state.eventDate) {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'chatbot', text: 'Please provide the event date.' },
						],
					});
				} else {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'user', text: this.state.eventDate },
						],
						step: 5,
					});
				}
				break;
			case 5:
				if (!this.state.eventPlace) {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'chatbot', text: 'Please provide the event place.' },
						],
					});
				} else {
					this.setState({
						messages: [
							...this.state.messages,
							{ type: 'user', text: this.state.eventPlace },
						],
					});
					const prompt = `Hi, my name is ${this.state.name}, and I would like to schedule ${this.state.numberOfEvents} events on ${this.state.eventDate} at ${this.state.eventPlace}.`;
					const response = await axios.post(
						this.apiEndpoint,
						{ prompt, max_tokens: 100 },
						{ headers: this.apiHeader },
					);
					const responseText = response.data.choices[0].text;
					this.setState({
						messages: [...this.state.messages, { type: 'chatbot', text: responseText }],
					});
				}
				break;
			default:
				break;
		}
	};

	render() {
		return (
			<div className="chat-container">
				{this.state.messages.map((message, index) => (
					<div key={index} className={`chat-message ${message.type}`}>
						<p>{message.text}</p>
					</div>
				))}
				{this.state.step === 1 && (
					<form onSubmit={this.handleSubmit}>
						<input
							type="text"
							name="name"
							value={this.state.name}
							onChange={this.handleChange}
							placeholder="Your name"
						/>
						<button type="submit">Submit</button>
					</form>
				)}
				{this.state.step === 2 && (
					<form onSubmit={this.handleSubmit}>
						<input
							type="text"
							name="phoneNumber"
							value={this.state.phoneNumber}
							onChange={this.handleChange}
							placeholder="Your phone number"
						/>
						<button type="submit">Submit</button>
					</form>
				)}
				{this.state.step === 3 && (
					<form onSubmit={this.handleSubmit}>
						<input
							type="text"
							name="numberOfEvents"
							value={this.state.numberOfEvents}
							onChange={this.handleChange}
							placeholder="Number of events"
						/>
						<button type="submit">Submit</button>
					</form>
				)}
				{this.state.step === 4 && (
					<form onSubmit={this.handleSubmit}>
						<input
							type="text"
							name="eventDate"
							value={this.state.eventDate}
							onChange={this.handleChange}
							placeholder="Event date"
						/>
						<button type="submit">Submit</button>
					</form>
				)}
				{this.state.step === 5 && (
					<form onSubmit={this.handleSubmit}>
						<input
							type="text"
							name="eventPlace"
							value={this.state.eventPlace}
							onChange={this.handleChange}
							placeholder="Event place"
						/>
						<button type="submit">Submit</button>
					</form>
				)}
			</div>
		);
	}
}

export default ChatContainer;
